interface PeriodBadgeProps {
  percentChange: number;
  direction: 'up' | 'down' | 'flat';
  /** If true, "down" is good (e.g., CPA going down) */
  invertColor?: boolean;
  label?: string;
}

export function PeriodBadge({ percentChange, direction, invertColor = false, label }: PeriodBadgeProps) {
  const isGood = invertColor ? direction === 'down' : direction === 'up';

  const colorClasses = direction === 'flat'
    ? 'text-[var(--ed-amber)] bg-[var(--ed-amber-bg)]'
    : isGood
      ? 'text-[var(--ed-green)] bg-[var(--ed-green-bg)]'
      : 'text-[var(--ed-red)] bg-[var(--ed-red-bg)]';

  const arrow = direction === 'up' ? '▲' : direction === 'down' ? '▼' : '—';
  const displayPct = Math.abs(percentChange).toFixed(1);

  return (
    <span className="inline-flex items-center gap-1">
      <span className={`text-[0.6rem] px-1.5 py-px rounded ${colorClasses}`}>
        {arrow} {displayPct}%
      </span>
      {label && <span className="text-[0.6rem] text-muted-foreground/60">{label}</span>}
    </span>
  );
}
